module.exports = __intlLocaleData;


//////////////////
// WEBPACK FOOTER
// external "__intlLocaleData"
// module id = ygro
// module chunks = 12